import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=524d09c1&scoped=true"
import script from "./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=524d09c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d09c1",
  null
  
)

export default component.exports